import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ActionExcelExport: FC<ILayoutToolsExportAction> = ({ onClick }) => {
  const { isDisabled } = useTools()

  return (
    <MenuItem
      p="2px 12px"
      bgColor="white"
      fontSize="sm"
      isDisabled={isDisabled}
      onClick={onClick}
      icon={<GrDocumentCsv />}
    >
      Exportar para Tabela
    </MenuItem>
  )
}

export default ActionExcelExport
